import dayjs from 'dayjs'
import { changeTimeLocalToUtc } from '../../../helper'
import { DATE_FORMAT } from '../../../utils/constants'

class TradeVanilla {
  constructor(form, currencyNormalize = {}) {
    this.trade_type = form.trade_type.name
    this.base_currency = form.currency_pair.substring(0, 3)
    this.counter_currency = form.currency_pair.substring(3, 6)
    this.quantity = Number(form.quantity)
    if (form.trade_type.name.includes('Client') && form.side) {
      this.side = form.side === 'BUY' ? 'SELL' : 'BUY'
    } else {
      this.side = form.side
    }
    this.counterparty = form.counterparty
    this.trade_date = changeTimeLocalToUtc(form.trade_date, DATE_FORMAT.REGULAR_DATE_TIME)
    this.settlement_date = form.settlement_date
      ? dayjs(form.settlement_date).format(DATE_FORMAT.REGULAR_DATE)
      : ''
    this.expiry = form.expiry ? dayjs(form.expiry).format(DATE_FORMAT.REGULAR_DATE) : ''
    this.put_call = form.put_call

    if (
      currencyNormalize.data &&
      (currencyNormalize?.data[this.base_currency]?.is_ndf ||
        currencyNormalize?.data[this.counter_currency]?.is_ndf)
    ) {
      this.fixing_source = form.fixing_source
      this.fixing_date = dayjs(form.expiry).format(DATE_FORMAT.REGULAR_DATE)
    }
    this.premium = Number(form.premium_amount)
    this.cut = form.cut
    this.strike = Number(form.strike)
    this.premium_date = form.premium_date
      ? dayjs(form.premium_date).format(DATE_FORMAT.REGULAR_DATE)
      : ''
    this.trader_name = form.trader_name
    this.premium_currency = form.premium_currency.name
    this.note = form.note
    this.direction = form.direction
    this.trade_origin = 'FXER'
  }
  // will work just when update
  isEqual(trade) {
    let { trade_date } = trade
    trade_date = dayjs(trade_date).format(DATE_FORMAT.REGULAR_DATE_TIME)
    trade.trade_type = trade.type
    trade.quantity = Math.abs(trade.client_quantity) || Math.abs(trade.market_maker_quantity)
    trade.counterparty = trade.client || trade.market_maker
    trade = new TradeVanilla(trade)
    trade.trade_date = trade_date
    for (const key of Object.keys(trade)) {
      if (this[key] !== trade[key]) {
        return false
      }
    }
    return true
  }
}

export default TradeVanilla
